"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearAll = exports.changeCustomerFailure = exports.changeCustomerSuccess = exports.changeCustomerRequest = exports.toggleModal = void 0;
const ActionTypes = require("../../actionTypes/project/change");
const toggleModal = () => ({
    type: ActionTypes.IS_MODAL_OPEN
});
exports.toggleModal = toggleModal;
const changeCustomerRequest = (payload) => ({
    type: ActionTypes.CHANGE_CUSTOMER_REQUEST,
    payload: payload
});
exports.changeCustomerRequest = changeCustomerRequest;
const changeCustomerSuccess = () => ({
    type: ActionTypes.CHANGE_CUSTOMER_SUCCESS
});
exports.changeCustomerSuccess = changeCustomerSuccess;
const changeCustomerFailure = (payload) => ({
    type: ActionTypes.CHANGE_CUSTOMER_FAILURE,
    payload
});
exports.changeCustomerFailure = changeCustomerFailure;
const clearAll = () => ({
    type: ActionTypes.CLEAR_ALL
});
exports.clearAll = clearAll;
//# sourceMappingURL=change.js.map